var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OutlinedIcon',[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-flask-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }